import { getEndPoint } from './getEndPoint'
export const getBlogPostsByPage = (page, filterName, filterValue) => {
  let endpoint = 'wp/v2/posts/?page=' + page
  if (filterName) endpoint += `&filter[${filterName}]=${filterValue}`
  endpoint += '&_embed'
  return getEndPoint(endpoint)
}
